// extracted by mini-css-extract-plugin
var _1 = "cGpxQtIqew7YwYPW5CEg";
export { _1 as "icon" }
